import { axiosInstance, handleApiRequest } from 'apis/apiClient';
import { ChatRequest, ChatResponse } from 'types/chat';

const chatAPI = {
  chat: async (chatRequest: ChatRequest) => {
    return handleApiRequest<ChatResponse>(
      axiosInstance.post('/bot/chat', chatRequest),
    );
  },
  exam: async (chatRequest: ChatRequest) => {
    return handleApiRequest<ChatResponse>(
      axiosInstance.post('/bot/exam', chatRequest),
    );
  },
  hint: async (chatRequest: ChatRequest) => {
    return handleApiRequest<ChatResponse>(
      axiosInstance.post('/bot/hint', chatRequest),
    );
  },
};

export default chatAPI;
